import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormControlLabel from '~components/form-control-label';
import BaseSwitch from './switch';

function Switch(props) {
  const {
    checked: checkedProp,
    defaultChecked,
    onChange,
    SwitchProps,
    displayLabel,
    ...otherProps
  } = props;

  const { t } = useTranslation();
  // used for uncontrolled Switch to display the correct label
  const [checkedInternalState, setCheckedInternalState] = useState(
    defaultChecked === undefined || defaultChecked === null || defaultChecked
  );

  const checked =
    checkedProp === undefined || checkedProp === null ? checkedInternalState : checkedProp;

  const handleSwitchChange = (e) => {
    if (onChange) onChange(e);
    setCheckedInternalState(e.target.checked);
  };

  return (
    <FormControlLabel
      {...otherProps}
      onChange={handleSwitchChange}
      control={<BaseSwitch {...SwitchProps} checked={checked} />}
      label={displayLabel ? (checked ? t('form.value.yes') : t('form.value.no')) : null}
    />
  );
}

Switch.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  SwitchProps: PropTypes.object,
  displayLabel: PropTypes.bool,
};

Switch.defaultProps = {
  checked: undefined,
  defaultChecked: undefined,
  onChange: undefined,
  SwitchProps: {},
  displayLabel: true,
};

export default Switch;
